import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import * as Luxon from 'luxon'
import { luxonDiffDay } from 'utils/time';

export default function usePeriodAction(days = 0) {
  const yesterday = Luxon.DateTime.now().startOf('day').minus({ days: 1 }).toFormat('yyyyMMdd');
  const [period_start, setPeriodStart] = Recoil.useRecoilState(AppStore.assets.period_start);
  const [period_end, setPeriodEnd] = Recoil.useRecoilState(AppStore.assets.period_end);
  const luxon_start = React.useMemo(() => Luxon.DateTime.fromFormat(period_start, 'yyyyMMdd'), [period_start]);
  const luxon_end = React.useMemo(() => Luxon.DateTime.fromFormat(period_end, 'yyyyMMdd'), [period_end]);
  const diff_days = React.useMemo(() => luxonDiffDay(luxon_start, luxon_end), [luxon_start, luxon_end]);
  const triggered = React.useMemo(() => Math.abs(days) === Math.abs(diff_days) && period_end === yesterday, [days, diff_days, period_end, yesterday]);
  const onTrigger = React.useCallback((callback) => () => {
    const luxon_start = Luxon.DateTime.fromFormat(yesterday, 'yyyyMMdd').plus({ days });
    const period_start = luxon_start.toFormat('yyyyMMdd');
    callback && callback(period_start, yesterday);
    setPeriodStart(() => period_start);
    setPeriodEnd(() => yesterday);
  }, [days, yesterday, setPeriodStart, setPeriodEnd]);
  return {
    diff: diff_days,
    triggered,
    onTrigger,
  };
}
